export default "__VITE_ASSET__DtpRvB12__"